//@ts-ignore
import { encodeCookie, removeCookie } from "@utils/CookieUtils";
export var saveValuationCookies = function saveValuationCookies(place) {
  var typologyID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var isSelling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  removeCookie("publicValuationRequestCookie");
  removeCookie("consentCookie");
  var publicValuation = {
    realEstateValuation: {
      latitude: place === null || place === void 0 ? void 0 : place.latitude,
      longitude: place === null || place === void 0 ? void 0 : place.longitude,
      cityID: place === null || place === void 0 ? void 0 : place.cityID,
      sale: true,
      sqM: null,
      rooms: null,
      address: (place === null || place === void 0 ? void 0 : place.address) || "",
      typologyID,
      macroTypologyID: 1,
      isSelling: isSelling
    }
  };
  encodeCookie("publicValuationCookie", publicValuation);
  encodeCookie("publicValuationCookieNew", publicValuation, undefined, false, true);
};
export var redirectToValuation = function redirectToValuation(place, typologyID) {
  var isSelling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!place) return;
  saveValuationCookies(place, typologyID, isSelling);
  location.href = window["_valuationStep2"];
};